// extracted by mini-css-extract-plugin
export var lg = "_1a-4";
export var md = "_1a-3";
export var sm = "_1a-2";
export var xs = "_1a-1";
export var xxs = "_1a-0";